/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'bypassDealById',
    message: messages.SUCCESS_BYPASS_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:objectId/bypass',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.BYPASS_DEAL,
    requestSchema: requestSchemas.deals.bypassDealById,
  },
  {
    action: 'cancelDealById',
    message: messages.SUCCESS_CANCEL_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:objectId/cancel/:compositeKey?',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CANCEL_DEAL,
    requestSchema: requestSchemas.deals.cancelDealById,
  },
  {
    action: 'createDealBySystemGameId',
    message: messages.SUCCESS_CREATE_DEAL_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/deal/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_DEAL,
    requestSchema: requestSchemas.deals.createDealBySystemGameId,
  },
  {
    action: 'editDealById',
    message: messages.SUCCESS_EDIT_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:objectId/edit',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.EDIT_DEAL,
    requestSchema: requestSchemas.deals.editDealById,
  },
  {
    action: 'getDealById',
    message: messages.SUCCESS_GET_DEAL_BY_ID,
    method: 'GET',
    path: '/deal/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DEAL,
    requestSchema: requestSchemas.deals.getDealById,
  },
  {
    action: 'getDealReceipt',
    message: messages.SUCCESS_GET_DEAL_RECEIPT,
    method: 'GET',
    path: '/deal/:dealId/receipt',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DEAL_RECEIPT,
    requestSchema: requestSchemas.deals.getDealReceipt,
  },
  {
    action: 'getDealsBySystemGameId',
    message: messages.SUCCESS_GET_DEALS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/deals/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DEAL,
    requestSchema: requestSchemas.deals.getDealsBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'printDealReceipt',
    message: messages.SUCCESS_PRINT_DEAL_RECEIPT,
    method: 'POST',
    path: '/deal/:dealId/receipt/print',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.PRINT_DEAL_RECEIPT,
    requestSchema: requestSchemas.deals.printDealReceipt,
  },
  {
    action: 'processDealById',
    message: messages.SUCCESS_PROCESS_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:objectId/process',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.PROCESS_DEAL,
    requestSchema: requestSchemas.deals.processDealById,
  },
  {
    action: 'restoreDealById',
    message: messages.SUCCESS_RESTORE_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:objectId/restore',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.RESTORE_DEAL,
    requestSchema: requestSchemas.deals.restoreDealById,
  },
  {
    action: 'shareDealReceipt',
    message: messages.SUCCESS_SHARE_DEAL_RECEIPT,
    method: 'POST',
    path: '/deal/:dealId/receipt/share',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.SHARE_DEAL_RECEIPT,
    requestSchema: requestSchemas.deals.shareDealReceipt,
  },
  {
    action: 'updateDealById',
    message: messages.SUCCESS_UPDATE_DEAL_BY_ID,
    method: 'PATCH',
    path: '/deal/:dealId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_DEAL,
    requestSchema: requestSchemas.deals.updateDealById,
  },
];
